import React, { useEffect, useRef, useState } from "react";
import PageLayout from "../../layout/PageLayout/pageLayout";
import search from "../../include/images/search.svg";
import action1 from "../../include/images/action-btn1.svg";
import action2 from "../../include/images/action-btn2.svg";
import action3 from "../../include/images/action-btn3.svg";
import backward from "../../include/images/backward.svg";
import forward from "../../include/images/forward.svg";

import { connect } from "react-redux";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import { deleteUserStory, getMyStories, updateUserStory, userStoryData } from "../../store/userStory";
import { getProfile } from "../../utils/localStorageServices";
import { toast } from "react-toastify";
import AlertError from "../../common/alerts/alertError";
import LoadingBar from "react-top-loading-bar";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Skeleton from "react-loading-skeleton";
import noRecord from "../../include/images/nrb-img.svg";
import { Dropdown } from "react-bootstrap";
import {
  capitalizeContentInBrackets,
  capitalizeFirstLetter,
  capitalizeFirstLetterWord,
} from "../../utils/helperFunctions";
import DeleteModal from "../../components/common/deleteModal/deleteModal";
import AlertSuccess from "../../common/alerts/alertSuccess";

const CustomerStoryList = (props) => {
  const [tab, setTab] = useState("all");
  const ref = useRef();
  const storyData = props?.userStoryData?.myStories?.data || [];

  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [loadingAction, setLoadingAction] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDelete, setShowDelete] = useState(false);

  const toggleDelete = () => {
    setShowDelete((prev) => !prev);
  };

  const profile = getProfile();
  const isAdmin = profile?.profile?.customerStoryType === "admin" ? true : false;

  const getStory = () => {
    setLoading(true);
    ref?.current?.continuousStart();
    const payload = {
      sort: "createdAt",
      order: "desc",
      page,
      createdBy: profile?.userId,
      keyword: searchKeyword?.replace(/[^a-zA-Z0-9 ]+/g, ""),
      limit: 20,
    };

    payload.status = tab === "all" ? "" : tab;

    props?.getUserStories(payload, (res) => {
      ref?.current?.complete();
      setLoading(false);
      if (res?.status != 200) {
        toast(<AlertError message={res?.data?.message || "Something went wrong!!"} />);
      }
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getStory();
  }, [tab, page, searchKeyword]);

  const totalCount = props?.userStoryData?.stories?.totalCount || 0;
  const dataPerPage = props?.userStoryData?.stories?.recordsPerPage || 0;
  const filteredCount = props?.userStoryData?.stories?.filteredCount || 0;
  const noOfPage = Math.ceil(totalCount / filteredCount) || 0;
  const currentPage = page || 1;

  const start = totalCount === 0 ? 0 : (currentPage - 1) * dataPerPage + 1;
  const end = Math.min(currentPage * dataPerPage, totalCount);

  const updateStatus = (item, selectedStatus) => {
    ref?.current?.continuousStart();
    setLoadingAction(true);
    props?.updateUserStory(item?.slug, { status: selectedStatus }, (res) => {
      ref?.current?.complete();
      setLoadingAction(false);
      if (res?.status == 200) {
        getStory();
      } else {
        toast(<AlertError message={res?.data?.message || "Something went wrong!!"} />);
      }
    });
  };

  const deleteHandler = (item) => {
    ref?.current?.continuousStart();
    setLoadingAction(true);
    props?.deleteUserStory(selectedItem?.slug, (res) => {
      ref?.current?.complete();
      setLoadingAction(false);
      if (res?.status === 200) {
        getStory();
        toggleDelete();
      } else {
        toast(<AlertError message={res?.data?.message || "Something went wrong"} />);
      }
    });
  };

  const getShareUrl = (slug) => {
    const baseUrl =
      process.env.REACT_APP_MODE === "development"
        ? "https://www.dev.environmentalinclusion.com/user-story"
        : "https://www.environmentalinclusion.com/user-story";
    return `${baseUrl}/${encodeURIComponent(slug)}`;
  };
  return (
    <>
      <LoadingBar height={5} color="#47AD1D" ref={ref} />
      <PageLayout>
        <div class="content-container story-list-container">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="breadcrumb-row d-flex flex-wrap mb-4">
                  <div class="breadcrumb-box">
                    <Link to="/">Home</Link>
                  </div>
                  <div class="breadcrumb-box">
                    <a href="javascript:void(0)">Stories List</a>
                  </div>
                </div>
                <div class="sl-title-row d-flex justify-content-between align-items-center mb-4">
                  <div class="sl-t-left">
                    <h1>Stories List</h1>
                  </div>
                  <div class="sl-t-right">
                    <Link to="/add-user-story" class="btn btn-default">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 3.75V14.25" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M3.75 9H14.25" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Create New
                    </Link>
                  </div>
                </div>
                <div class="sl-tab-container">
                  <div class="sl-tab-row d-none d-lg-flex align-items-start justify-content-start">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button
                          class={`nav-link ${tab === "all" ? "active" : ""}`}
                          id="tab1"
                          data-bs-toggle="tab"
                          data-bs-target="#tab1-pane"
                          type="button"
                          role="tab"
                          aria-controls="tab1-pane"
                          aria-selected="true"
                          onClick={() => setTab("all")}
                        >
                          All Stories
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class={`nav-link ${tab === "developing" ? "active" : ""}`}
                          id="tab2"
                          data-bs-toggle="tab"
                          data-bs-target="#tab2-pane"
                          type="button"
                          role="tab"
                          aria-controls="tab2-pane"
                          aria-selected="false"
                          onClick={() => setTab("developing")}
                        >
                          Developing
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class={`nav-link ${tab === "approval pending" ? "active" : ""}`}
                          id="tab3"
                          data-bs-toggle="tab"
                          data-bs-target="#tab3-pane"
                          type="button"
                          role="tab"
                          aria-controls="tab3-pane"
                          aria-selected="false"
                          onClick={() => setTab("approval pending")}
                        >
                          Approval Pending
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class={`nav-link ${tab === "approved" ? "active" : ""}`}
                          id="tab4"
                          data-bs-toggle="tab"
                          data-bs-target="#tab4-pane"
                          type="button"
                          role="tab"
                          aria-controls="tab4-pane"
                          aria-selected="false"
                          onClick={() => setTab("approved")}
                        >
                          Approved
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class={`nav-link ${tab === "published" ? "active" : ""}`}
                          id="tab5"
                          data-bs-toggle="tab"
                          data-bs-target="#tab5-pane"
                          type="button"
                          role="tab"
                          aria-controls="tab5-pane"
                          aria-selected="false"
                          onClick={() => setTab("published")}
                        >
                          Published
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class={`nav-link ${tab === "archived" ? "active" : ""}`}
                          id="tab6"
                          data-bs-toggle="tab"
                          data-bs-target="#tab6-pane"
                          type="button"
                          role="tab"
                          aria-controls="tab6-pane"
                          aria-selected="false"
                          onClick={() => setTab("archived")}
                        >
                          Archived
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class={`nav-link ${tab === "deleted" ? "active" : ""}`}
                          id="tab7"
                          data-bs-toggle="tab"
                          data-bs-target="#tab7-pane"
                          type="button"
                          role="tab"
                          aria-controls="tab7-pane"
                          aria-selected="false"
                          onClick={() => setTab("deleted")}
                        >
                          Deleted
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div class="accordion tab-content" id="accordionExample">
                    <div
                      class="tab-pane fade show active"
                      id="tab1-pane"
                      role="tabpanel"
                      aria-labelledby="tab1"
                      tabindex="0"
                    >
                      <div class="accordion-head d-lg-none">
                        <button
                          class="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          All Stories
                        </button>
                      </div>
                      <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div class="story-filters-row d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between gap-3 gap-lg-2">
                          <div class="story-filters-search">
                            <div class="page-search-block">
                              <button type="button">
                                <img src={search} alt="" />
                              </button>
                              <input
                                type="search"
                                class="form-control"
                                placeholder="Search"
                                onChange={(e) => setSearchKeyword(e.target.value)}
                                value={searchKeyword}
                              />
                            </div>
                          </div>
                        </div>
                        <div class="story-table ss-table-height">
                          <div class="table-responsive">
                            <table class="table filter-story-table ss-filter-story-table ss-table-height">
                              <thead>
                                <tr>
                                  <th style={{ width: "72px" }}>Photos</th>
                                  <th style={{ width: "auto", minWidth: "344px", maxWidth: "344px" }}>Title</th>
                                  <th style={{ width: "236px", minWidth: "236px" }}>Contributor</th>
                                  <th style={{ width: "134px" }}>Category</th>

                                  <th style={{ width: "144px" }}>Animal</th>
                                  <th style={{ width: "185px;", minWidth: "185px" }}>Status</th>
                                  <th style={{ width: "132px;" }}>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  [1, 2, 3, 4, 5, 6]?.map((item) => (
                                    <tr>
                                      <td>
                                        <Skeleton height={"35px"} width={"40px"} />
                                      </td>
                                      <td>
                                        <Skeleton height={"35px"} width={"344px"} />
                                      </td>
                                      <td>
                                        <div class="author-detail d-flex">
                                          <div class="author-img">
                                            <Skeleton height={"35px"} width={"35px"} />
                                          </div>
                                          <div class="author-text">
                                            <Skeleton height={"35px"} width={"190px"} />
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <Skeleton height={"35px"} width={"134px"} />
                                      </td>
                                      <td>
                                        <Skeleton height={"35px"} width={"144px"} />
                                      </td>
                                      <td>
                                        <Skeleton height={"35px"} width={"150px"} />
                                      </td>
                                      <td>
                                        <div class="action-btn-wrap d-flex align-items-center justify-content-center">
                                          <div>
                                            <Skeleton height={"20px"} width={"20px"} />
                                          </div>
                                          <div>
                                            <button
                                              type="button"
                                              class="action-btn d-flex align-items-center justify-content-center"
                                            >
                                              <Skeleton height={"20px"} width={"20px"} />
                                            </button>
                                          </div>
                                          <div>
                                            <button
                                              type="button"
                                              class="action-btn d-flex align-items-center justify-content-center"
                                            >
                                              <Skeleton height={"20px"} width={"20px"} />
                                            </button>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))
                                ) : storyData?.length > 0 ? (
                                  storyData?.map((item) => (
                                    <tr>
                                      <td>
                                        {item?.status == "published" ? (
                                          <Link to={`/user-story/${item?.slug}`} class="photo-wrap">
                                            <img
                                              className="ss-story-img"
                                              src={process.env.REACT_APP_MEDIA + item?.featuredImage[0]?.original}
                                              alt=""
                                            />
                                          </Link>
                                        ) : (
                                          <Link
                                            to={{
                                              pathname: "/user-story-preview",
                                              state: { slug: item?.slug },
                                            }}
                                            class="story-title "
                                          >
                                            <img
                                              className="ss-story-img"
                                              src={process.env.REACT_APP_MEDIA + item?.featuredImage?.[0]?.original}
                                              alt=""
                                            />
                                          </Link>
                                        )}
                                      </td>
                                      <td>
                                        {item?.status == "published" ? (
                                          <Link to={{ pathname: `/user-story/${item?.slug}` }} class="story-title">
                                            {item?.title}
                                          </Link>
                                        ) : (
                                          <Link
                                            to={{
                                              pathname: "/user-story-preview",
                                              state: { slug: item?.slug },
                                            }}
                                            class="story-title "
                                          >
                                            {item?.title}
                                          </Link>
                                        )}
                                      </td>
                                      <td>
                                        <div class="author-detail d-flex">
                                          <div class="author-img">
                                            <img
                                              src={
                                                process.env.REACT_APP_MEDIA + item?.createdBy?.profilePicture?.original
                                              }
                                              alt=""
                                            />
                                          </div>
                                          <div class="author-text">
                                            <h3>
                                              {item?.contributor?.length > 50
                                                ? item?.contributor?.slice(0, 50) + "..."
                                                : item?.contributor}
                                            </h3>
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        {Array.from(
                                          new Set(
                                            item?.species?.map((iu) =>
                                              capitalizeFirstLetterWord(iu?.speciesCategoryName),
                                            ),
                                          ),
                                        ).join(", ")}
                                      </td>
                                      <td>
                                        {[...new Map(item?.species?.map((s) => [s.slug, s])).values()].map(
                                          (it, index, arr) => (
                                            <React.Fragment key={it.slug}>
                                              <Link to={`/endangered-species/${it.slug}`}>
                                                {capitalizeFirstLetterWord(it.displayCommonName)}
                                              </Link>
                                              {index < arr.length - 1 && ", "}
                                            </React.Fragment>
                                          ),
                                        )}
                                      </td>

                                      <td class="position-relative">
                                        {item?.status === "deleted" ? (
                                          <button
                                            className={`btn color-btn cursor-default ${
                                              item?.status == "developing"
                                                ? "color-btn-blue"
                                                : item?.status == "approval pending"
                                                ? "color-btn-yellow"
                                                : item?.status == "archived"
                                                ? "color-btn-red"
                                                : item?.status == "published"
                                                ? "color-btn-green"
                                                : item?.status == "approved"
                                                ? "color-btn-approved"
                                                : ""
                                            } d-flex align-items-center justify-content-between w-100`}
                                            aria-expanded="false"
                                          >
                                            Deleted
                                          </button>
                                        ) : (
                                          <Dropdown className="dropdown">
                                            <Dropdown.Toggle
                                              as={"button"}
                                              className={`btn color-btn ${
                                                item?.status == "developing"
                                                  ? "color-btn-blue"
                                                  : item?.status == "approval pending"
                                                  ? "color-btn-yellow"
                                                  : item?.status == "archived"
                                                  ? "color-btn-red"
                                                  : item?.status == "published"
                                                  ? "color-btn-green"
                                                  : item?.status == "approved"
                                                  ? "color-btn-approved"
                                                  : ""
                                              }  dropdown-toggle d-flex align-items-center justify-content-between w-100"
                                            type="button`}
                                              data-bs-toggle="dropdown"
                                              aria-expanded="false"
                                            >
                                              {capitalizeFirstLetter(item?.status)}
                                              <svg
                                                class="arrow ms-1"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M4 6L8 10L12 6"
                                                  stroke="currentColor"
                                                  stroke-width="1.5"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                />
                                              </svg>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu as={"ul"} className="dropdown-menu">
                                              {item?.status != "developing" && (
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                      setSelectedItem(item);
                                                      updateStatus(item, "developing");
                                                    }}
                                                  >
                                                    Developing
                                                  </a>
                                                </li>
                                              )}
                                              {item?.status != "approval pending" && (
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                      setSelectedItem(item);
                                                      updateStatus(item, "approval pending");
                                                    }}
                                                  >
                                                    Approval Pending
                                                  </a>
                                                </li>
                                              )}
                                              {isAdmin && item?.status != "approved" && (
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                      setSelectedItem(item);
                                                      updateStatus(item, "approved");
                                                    }}
                                                  >
                                                    Approved
                                                  </a>
                                                </li>
                                              )}
                                              {isAdmin && item?.status != "published" && (
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                      setSelectedItem(item);
                                                      updateStatus(item, "published");
                                                    }}
                                                  >
                                                    Published
                                                  </a>
                                                </li>
                                              )}
                                              {isAdmin && item?.status != "archived" && (
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    href="javascript:void(0)"
                                                    onClick={() => {
                                                      setSelectedItem(item);
                                                      updateStatus(item, "archived");
                                                    }}
                                                  >
                                                    Archived
                                                  </a>
                                                </li>
                                              )}
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        )}
                                      </td>
                                      <td>
                                        {item?.status == "deleted" ? (
                                          ""
                                        ) : (
                                          <div class="action-btn-wrap d-flex align-items-center justify-content-center">
                                            <div>
                                              <Link
                                                to={`/update-user-story/${item?.slug}`}
                                                class="action-btn d-flex align-items-center justify-content-center"
                                              >
                                                <img src={action1} alt="" />
                                              </Link>
                                            </div>
                                            <div>
                                              <button
                                                class="action-btn d-flex align-items-center justify-content-center"
                                                onClick={() => {
                                                  setSelectedItem(item);
                                                  toggleDelete();
                                                }}
                                              >
                                                <img src={action2} alt="" />
                                              </button>
                                            </div>
                                            {item?.status === "published" ? (
                                              <div>
                                                <Dropdown class="action-btn d-flex align-items-center justify-content-center">
                                                  <Dropdown.Toggle as={"div"} className="ss-share-icon">
                                                    <img src={action3} alt="" />
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu className="dropdown-menu share-post">
                                                    <FacebookShareButton
                                                      url={getShareUrl(item?.slug)}
                                                      description={item?.description}
                                                      className="custom-share-post"
                                                    >
                                                      <Dropdown.Item className="dropdown-item" eventKey={"1"}>
                                                        <Link
                                                          to="#"
                                                          className="dropdown-item-link w-100 h-100 d-flex flex-wrap align-items-center"
                                                        >
                                                          <div className="dropdown-item-icon d-flex flex-wrap align-items-center justify-content-center">
                                                            <svg
                                                              width="20"
                                                              height="21"
                                                              viewBox="0 0 20 21"
                                                              fill="none"
                                                              xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                              <path
                                                                d="M10.7974 16.1444V10.7915H12.5942L12.8637 8.70543H10.7974V7.37352C10.7974 6.76958 10.9652 6.35797 11.8313 6.35797H12.936V4.49269C12.4013 4.43612 11.8639 4.40872 11.3263 4.41061C9.73351 4.41061 8.64314 5.38274 8.64314 7.16813V8.70543H6.8418V10.7915H8.64314V16.1444H10.7974Z"
                                                                fill="currentColor"
                                                              />
                                                            </svg>
                                                          </div>

                                                          <div className="dropdown-item-text custom-share-dropdown-text">
                                                            Facebook
                                                          </div>
                                                        </Link>
                                                      </Dropdown.Item>
                                                    </FacebookShareButton>
                                                    <TwitterShareButton
                                                      url={getShareUrl(item?.slug)}
                                                      className="custom-share-post"
                                                    >
                                                      <Dropdown.Item className="dropdown-item" eventKey={"2"}>
                                                        <Link
                                                          to="#"
                                                          className="dropdown-item-link w-100 h-100 d-flex flex-wrap align-items-center"
                                                        >
                                                          <div className="dropdown-item-icon d-flex flex-wrap align-items-center justify-content-center">
                                                            <svg
                                                              width="20"
                                                              height="21"
                                                              viewBox="0 0 20 21"
                                                              fill="none"
                                                              xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                              <path
                                                                d="M3.0317 5L8.05085 11.6187L3 17H4.13674L8.55875 12.2886L12.1316 17H16L10.6984 10.009L15.3997 5H14.263L10.1905 9.33911L6.90008 5H3.0317ZM4.70336 5.8258H6.48051L14.3281 16.1741H12.5509L4.70336 5.8258Z"
                                                                fill="currentColor"
                                                              />
                                                            </svg>
                                                          </div>

                                                          <div className="dropdown-item-text custom-share-dropdown-text">
                                                            Twitter
                                                          </div>
                                                        </Link>
                                                      </Dropdown.Item>
                                                    </TwitterShareButton>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </div>
                                            ) : (
                                              <div>
                                                <div class="action-btn d-flex align-items-center justify-content-center"></div>
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr style={{ minHeight: "200px", height: "200px" }}>
                                    <td colSpan={"6"} className="empty-td ">
                                      <div className="d-flex justify-content-center align-items-center">
                                        <div>
                                          <img src={noRecord} alt="" />
                                          <p className="mt-2 fw-bold500">No Records Found</p>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                            {storyData?.length !== 0 && (
                              <div class="pagination-holder d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center gap-2">
                                  <span class="text-muted">
                                    {" "}
                                    {start} - {end}
                                  </span>
                                  <span class="text-muted">of {totalCount}</span>

                                  <div class="pagination d-flex align-items-center gap-2">
                                    <button
                                      class={`link ${currentPage != 1 ? "" : "cursor-default"}`}
                                      aria-label="Previous"
                                      onClick={() => {
                                        if (currentPage != 1) {
                                          setPage(page - 1);
                                        }
                                      }}
                                    >
                                      <img src={backward} alt="" />
                                    </button>
                                    <button
                                      class={`link ${currentPage < noOfPage ? "" : "cursor-default"}`}
                                      aria-label="Next"
                                      onClick={() => {
                                        if (currentPage < noOfPage) {
                                          setPage(page + 1);
                                        }
                                      }}
                                    >
                                      <img src={forward} alt="" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageLayout>
      <DeleteModal show={showDelete} onHide={toggleDelete} loading={loadingAction} deleteHandler={deleteHandler} />
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getUserStories: (params, callback) => dispatch(getMyStories(params, callback)),
  updateUserStory: (id, data, callback) => dispatch(updateUserStory(id, data, callback)),
  deleteUserStory: (params, callback) => dispatch(deleteUserStory(params, callback)),
});

const mapStateToProps = (state) => ({
  userStoryData: userStoryData(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(CustomerStoryList));
